<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      class="pb-0"
      maxwidth-container="830px"
      rodape
    >
      <TituloPagina :titulo="tituloPagina" class="mt-7 mt-md-11" />

      <ListaContainer
        :lista="listaMenu"
        data-cy="lista_meu_perfil"
      />
    </InternaMain>
    <Rodape />
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import Rodape from '@/components/Rodape.vue';
import ListaContainer from '@/components/Lista/ListaContainer.vue';

export default {
  name: 'MeuPerfil',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    Rodape,
    ListaContainer,
  },

  data() {
    return {
      tituloPagina: 'Meu perfil',
      listaMenu: [
        {
          link: true,
          label: 'Dados pessoais',
          para: '/meu-perfil/dados-pessoais',
          datacy: 'btn_dados_pessoais',
        },
        // {
        //   link: true,
        //   label: 'Endereços',
        //   para: '/meu-perfil/enderecos',
        //   datacy: 'btn_enderecos',
        // },
        {
          link: false,
          label: 'Financeiro',
        },
        {
          link: true,
          label: 'Cartões de crédito',
          para: '/meu-perfil/cartoes-credito',
          datacy: 'btn_cartoes_de_credito',
        },
        // {
        //   link: true,
        //   label: 'Contas bancárias',
        //   para: '/meu-perfil/contas-bancarias',
        //   datacy: 'btn_contas-bancarias',
        // },
        {
          link: false,
          label: 'Segurança',
        },
        {
          link: true,
          label: 'Alterar minha senha',
          para: '/meu-perfil/alterar-senha',
          datacy: 'btn_alterar_a_minha_senha',
        },
      ],
    };
  },

};

</script>

<style lang="scss">
  .subheaderHeight{height: 20px !important;}
</style>
